"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BrowserClient", {
  enumerable: true,
  get: function () {
    return _client.BrowserClient;
  }
});
Object.defineProperty(exports, "OpenFeatureIntegrationHook", {
  enumerable: true,
  get: function () {
    return _integration3.OpenFeatureIntegrationHook;
  }
});
Object.defineProperty(exports, "SDK_VERSION", {
  enumerable: true,
  get: function () {
    return _core.SDK_VERSION;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", {
  enumerable: true,
  get: function () {
    return _core.SEMANTIC_ATTRIBUTE_SENTRY_OP;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", {
  enumerable: true,
  get: function () {
    return _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", {
  enumerable: true,
  get: function () {
    return _core.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", {
  enumerable: true,
  get: function () {
    return _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
  }
});
Object.defineProperty(exports, "Scope", {
  enumerable: true,
  get: function () {
    return _core.Scope;
  }
});
Object.defineProperty(exports, "WINDOW", {
  enumerable: true,
  get: function () {
    return _helpers.WINDOW;
  }
});
Object.defineProperty(exports, "addBreadcrumb", {
  enumerable: true,
  get: function () {
    return _core.addBreadcrumb;
  }
});
Object.defineProperty(exports, "addEventProcessor", {
  enumerable: true,
  get: function () {
    return _core.addEventProcessor;
  }
});
Object.defineProperty(exports, "addIntegration", {
  enumerable: true,
  get: function () {
    return _core.addIntegration;
  }
});
Object.defineProperty(exports, "addTracingExtensions", {
  enumerable: true,
  get: function () {
    return _core.addTracingExtensions;
  }
});
Object.defineProperty(exports, "breadcrumbsIntegration", {
  enumerable: true,
  get: function () {
    return _breadcrumbs.breadcrumbsIntegration;
  }
});
Object.defineProperty(exports, "browserApiErrorsIntegration", {
  enumerable: true,
  get: function () {
    return _browserapierrors.browserApiErrorsIntegration;
  }
});
Object.defineProperty(exports, "browserProfilingIntegration", {
  enumerable: true,
  get: function () {
    return _integration.browserProfilingIntegration;
  }
});
Object.defineProperty(exports, "browserSessionIntegration", {
  enumerable: true,
  get: function () {
    return _browsersession.browserSessionIntegration;
  }
});
Object.defineProperty(exports, "browserTracingIntegration", {
  enumerable: true,
  get: function () {
    return _browserTracingIntegration.browserTracingIntegration;
  }
});
Object.defineProperty(exports, "buildLaunchDarklyFlagUsedHandler", {
  enumerable: true,
  get: function () {
    return _integration2.buildLaunchDarklyFlagUsedHandler;
  }
});
Object.defineProperty(exports, "captureConsoleIntegration", {
  enumerable: true,
  get: function () {
    return _core.captureConsoleIntegration;
  }
});
Object.defineProperty(exports, "captureEvent", {
  enumerable: true,
  get: function () {
    return _core.captureEvent;
  }
});
Object.defineProperty(exports, "captureException", {
  enumerable: true,
  get: function () {
    return _core.captureException;
  }
});
Object.defineProperty(exports, "captureFeedback", {
  enumerable: true,
  get: function () {
    return _core.captureFeedback;
  }
});
Object.defineProperty(exports, "captureMessage", {
  enumerable: true,
  get: function () {
    return _core.captureMessage;
  }
});
Object.defineProperty(exports, "captureSession", {
  enumerable: true,
  get: function () {
    return _core.captureSession;
  }
});
Object.defineProperty(exports, "captureUserFeedback", {
  enumerable: true,
  get: function () {
    return _sdk.captureUserFeedback;
  }
});
Object.defineProperty(exports, "chromeStackLineParser", {
  enumerable: true,
  get: function () {
    return _stackParsers.chromeStackLineParser;
  }
});
Object.defineProperty(exports, "close", {
  enumerable: true,
  get: function () {
    return _core.close;
  }
});
Object.defineProperty(exports, "contextLinesIntegration", {
  enumerable: true,
  get: function () {
    return _contextlines.contextLinesIntegration;
  }
});
Object.defineProperty(exports, "continueTrace", {
  enumerable: true,
  get: function () {
    return _core.continueTrace;
  }
});
Object.defineProperty(exports, "createTransport", {
  enumerable: true,
  get: function () {
    return _core.createTransport;
  }
});
Object.defineProperty(exports, "createUserFeedbackEnvelope", {
  enumerable: true,
  get: function () {
    return _userfeedback.createUserFeedbackEnvelope;
  }
});
Object.defineProperty(exports, "debugIntegration", {
  enumerable: true,
  get: function () {
    return _core.debugIntegration;
  }
});
Object.defineProperty(exports, "dedupeIntegration", {
  enumerable: true,
  get: function () {
    return _core.dedupeIntegration;
  }
});
Object.defineProperty(exports, "defaultRequestInstrumentationOptions", {
  enumerable: true,
  get: function () {
    return _request.defaultRequestInstrumentationOptions;
  }
});
Object.defineProperty(exports, "defaultStackLineParsers", {
  enumerable: true,
  get: function () {
    return _stackParsers.defaultStackLineParsers;
  }
});
Object.defineProperty(exports, "defaultStackParser", {
  enumerable: true,
  get: function () {
    return _stackParsers.defaultStackParser;
  }
});
Object.defineProperty(exports, "endSession", {
  enumerable: true,
  get: function () {
    return _core.endSession;
  }
});
Object.defineProperty(exports, "eventFromException", {
  enumerable: true,
  get: function () {
    return _eventbuilder.eventFromException;
  }
});
Object.defineProperty(exports, "eventFromMessage", {
  enumerable: true,
  get: function () {
    return _eventbuilder.eventFromMessage;
  }
});
Object.defineProperty(exports, "exceptionFromError", {
  enumerable: true,
  get: function () {
    return _eventbuilder.exceptionFromError;
  }
});
Object.defineProperty(exports, "extraErrorDataIntegration", {
  enumerable: true,
  get: function () {
    return _core.extraErrorDataIntegration;
  }
});
Object.defineProperty(exports, "featureFlagsIntegration", {
  enumerable: true,
  get: function () {
    return _featureFlagsIntegration.featureFlagsIntegration;
  }
});
Object.defineProperty(exports, "feedbackAsyncIntegration", {
  enumerable: true,
  get: function () {
    return _feedbackAsync.feedbackAsyncIntegration;
  }
});
Object.defineProperty(exports, "feedbackIntegration", {
  enumerable: true,
  get: function () {
    return _feedbackSync.feedbackSyncIntegration;
  }
});
Object.defineProperty(exports, "feedbackSyncIntegration", {
  enumerable: true,
  get: function () {
    return _feedbackSync.feedbackSyncIntegration;
  }
});
Object.defineProperty(exports, "flush", {
  enumerable: true,
  get: function () {
    return _core.flush;
  }
});
Object.defineProperty(exports, "forceLoad", {
  enumerable: true,
  get: function () {
    return _sdk.forceLoad;
  }
});
Object.defineProperty(exports, "functionToStringIntegration", {
  enumerable: true,
  get: function () {
    return _core.functionToStringIntegration;
  }
});
Object.defineProperty(exports, "geckoStackLineParser", {
  enumerable: true,
  get: function () {
    return _stackParsers.geckoStackLineParser;
  }
});
Object.defineProperty(exports, "getActiveSpan", {
  enumerable: true,
  get: function () {
    return _core.getActiveSpan;
  }
});
Object.defineProperty(exports, "getClient", {
  enumerable: true,
  get: function () {
    return _core.getClient;
  }
});
Object.defineProperty(exports, "getCurrentHub", {
  enumerable: true,
  get: function () {
    return _core.getCurrentHub;
  }
});
Object.defineProperty(exports, "getCurrentScope", {
  enumerable: true,
  get: function () {
    return _core.getCurrentScope;
  }
});
Object.defineProperty(exports, "getDefaultIntegrations", {
  enumerable: true,
  get: function () {
    return _sdk.getDefaultIntegrations;
  }
});
Object.defineProperty(exports, "getFeedback", {
  enumerable: true,
  get: function () {
    return _feedback.getFeedback;
  }
});
Object.defineProperty(exports, "getGlobalScope", {
  enumerable: true,
  get: function () {
    return _core.getGlobalScope;
  }
});
Object.defineProperty(exports, "getIsolationScope", {
  enumerable: true,
  get: function () {
    return _core.getIsolationScope;
  }
});
Object.defineProperty(exports, "getReplay", {
  enumerable: true,
  get: function () {
    return _replay.getReplay;
  }
});
Object.defineProperty(exports, "getRootSpan", {
  enumerable: true,
  get: function () {
    return _core.getRootSpan;
  }
});
Object.defineProperty(exports, "getSpanDescendants", {
  enumerable: true,
  get: function () {
    return _core.getSpanDescendants;
  }
});
Object.defineProperty(exports, "getSpanStatusFromHttpCode", {
  enumerable: true,
  get: function () {
    return _core.getSpanStatusFromHttpCode;
  }
});
Object.defineProperty(exports, "globalHandlersIntegration", {
  enumerable: true,
  get: function () {
    return _globalhandlers.globalHandlersIntegration;
  }
});
Object.defineProperty(exports, "httpClientIntegration", {
  enumerable: true,
  get: function () {
    return _httpclient.httpClientIntegration;
  }
});
Object.defineProperty(exports, "httpContextIntegration", {
  enumerable: true,
  get: function () {
    return _httpcontext.httpContextIntegration;
  }
});
Object.defineProperty(exports, "inboundFiltersIntegration", {
  enumerable: true,
  get: function () {
    return _core.inboundFiltersIntegration;
  }
});
Object.defineProperty(exports, "init", {
  enumerable: true,
  get: function () {
    return _sdk.init;
  }
});
Object.defineProperty(exports, "instrumentOutgoingRequests", {
  enumerable: true,
  get: function () {
    return _request.instrumentOutgoingRequests;
  }
});
Object.defineProperty(exports, "isInitialized", {
  enumerable: true,
  get: function () {
    return _core.isInitialized;
  }
});
Object.defineProperty(exports, "lastEventId", {
  enumerable: true,
  get: function () {
    return _core.lastEventId;
  }
});
Object.defineProperty(exports, "launchDarklyIntegration", {
  enumerable: true,
  get: function () {
    return _integration2.launchDarklyIntegration;
  }
});
Object.defineProperty(exports, "lazyLoadIntegration", {
  enumerable: true,
  get: function () {
    return _lazyLoadIntegration.lazyLoadIntegration;
  }
});
Object.defineProperty(exports, "linkedErrorsIntegration", {
  enumerable: true,
  get: function () {
    return _linkederrors.linkedErrorsIntegration;
  }
});
Object.defineProperty(exports, "makeBrowserOfflineTransport", {
  enumerable: true,
  get: function () {
    return _offline.makeBrowserOfflineTransport;
  }
});
Object.defineProperty(exports, "makeFetchTransport", {
  enumerable: true,
  get: function () {
    return _fetch.makeFetchTransport;
  }
});
Object.defineProperty(exports, "makeMultiplexedTransport", {
  enumerable: true,
  get: function () {
    return _core.makeMultiplexedTransport;
  }
});
Object.defineProperty(exports, "metrics", {
  enumerable: true,
  get: function () {
    return _metrics.metrics;
  }
});
Object.defineProperty(exports, "moduleMetadataIntegration", {
  enumerable: true,
  get: function () {
    return _core.moduleMetadataIntegration;
  }
});
Object.defineProperty(exports, "onLoad", {
  enumerable: true,
  get: function () {
    return _sdk.onLoad;
  }
});
Object.defineProperty(exports, "openFeatureIntegration", {
  enumerable: true,
  get: function () {
    return _integration3.openFeatureIntegration;
  }
});
Object.defineProperty(exports, "opera10StackLineParser", {
  enumerable: true,
  get: function () {
    return _stackParsers.opera10StackLineParser;
  }
});
Object.defineProperty(exports, "opera11StackLineParser", {
  enumerable: true,
  get: function () {
    return _stackParsers.opera11StackLineParser;
  }
});
Object.defineProperty(exports, "parameterize", {
  enumerable: true,
  get: function () {
    return _core.parameterize;
  }
});
Object.defineProperty(exports, "registerSpanErrorInstrumentation", {
  enumerable: true,
  get: function () {
    return _core.registerSpanErrorInstrumentation;
  }
});
Object.defineProperty(exports, "replayCanvasIntegration", {
  enumerable: true,
  get: function () {
    return _replayCanvas.replayCanvasIntegration;
  }
});
Object.defineProperty(exports, "replayIntegration", {
  enumerable: true,
  get: function () {
    return _replay.replayIntegration;
  }
});
Object.defineProperty(exports, "reportingObserverIntegration", {
  enumerable: true,
  get: function () {
    return _reportingobserver.reportingObserverIntegration;
  }
});
Object.defineProperty(exports, "rewriteFramesIntegration", {
  enumerable: true,
  get: function () {
    return _core.rewriteFramesIntegration;
  }
});
Object.defineProperty(exports, "sendFeedback", {
  enumerable: true,
  get: function () {
    return _feedback.sendFeedback;
  }
});
Object.defineProperty(exports, "sessionTimingIntegration", {
  enumerable: true,
  get: function () {
    return _core.sessionTimingIntegration;
  }
});
Object.defineProperty(exports, "setContext", {
  enumerable: true,
  get: function () {
    return _core.setContext;
  }
});
Object.defineProperty(exports, "setCurrentClient", {
  enumerable: true,
  get: function () {
    return _core.setCurrentClient;
  }
});
Object.defineProperty(exports, "setExtra", {
  enumerable: true,
  get: function () {
    return _core.setExtra;
  }
});
Object.defineProperty(exports, "setExtras", {
  enumerable: true,
  get: function () {
    return _core.setExtras;
  }
});
Object.defineProperty(exports, "setHttpStatus", {
  enumerable: true,
  get: function () {
    return _core.setHttpStatus;
  }
});
Object.defineProperty(exports, "setMeasurement", {
  enumerable: true,
  get: function () {
    return _core.setMeasurement;
  }
});
Object.defineProperty(exports, "setTag", {
  enumerable: true,
  get: function () {
    return _core.setTag;
  }
});
Object.defineProperty(exports, "setTags", {
  enumerable: true,
  get: function () {
    return _core.setTags;
  }
});
Object.defineProperty(exports, "setUser", {
  enumerable: true,
  get: function () {
    return _core.setUser;
  }
});
Object.defineProperty(exports, "showReportDialog", {
  enumerable: true,
  get: function () {
    return _sdk.showReportDialog;
  }
});
Object.defineProperty(exports, "spanToBaggageHeader", {
  enumerable: true,
  get: function () {
    return _core.spanToBaggageHeader;
  }
});
Object.defineProperty(exports, "spanToJSON", {
  enumerable: true,
  get: function () {
    return _core.spanToJSON;
  }
});
Object.defineProperty(exports, "spanToTraceHeader", {
  enumerable: true,
  get: function () {
    return _core.spanToTraceHeader;
  }
});
Object.defineProperty(exports, "spotlightBrowserIntegration", {
  enumerable: true,
  get: function () {
    return _spotlight.spotlightBrowserIntegration;
  }
});
Object.defineProperty(exports, "startBrowserTracingNavigationSpan", {
  enumerable: true,
  get: function () {
    return _browserTracingIntegration.startBrowserTracingNavigationSpan;
  }
});
Object.defineProperty(exports, "startBrowserTracingPageLoadSpan", {
  enumerable: true,
  get: function () {
    return _browserTracingIntegration.startBrowserTracingPageLoadSpan;
  }
});
Object.defineProperty(exports, "startInactiveSpan", {
  enumerable: true,
  get: function () {
    return _core.startInactiveSpan;
  }
});
Object.defineProperty(exports, "startNewTrace", {
  enumerable: true,
  get: function () {
    return _core.startNewTrace;
  }
});
Object.defineProperty(exports, "startSession", {
  enumerable: true,
  get: function () {
    return _core.startSession;
  }
});
Object.defineProperty(exports, "startSpan", {
  enumerable: true,
  get: function () {
    return _core.startSpan;
  }
});
Object.defineProperty(exports, "startSpanManual", {
  enumerable: true,
  get: function () {
    return _core.startSpanManual;
  }
});
Object.defineProperty(exports, "statsigIntegration", {
  enumerable: true,
  get: function () {
    return _integration5.statsigIntegration;
  }
});
Object.defineProperty(exports, "suppressTracing", {
  enumerable: true,
  get: function () {
    return _core.suppressTracing;
  }
});
Object.defineProperty(exports, "thirdPartyErrorFilterIntegration", {
  enumerable: true,
  get: function () {
    return _core.thirdPartyErrorFilterIntegration;
  }
});
Object.defineProperty(exports, "unleashIntegration", {
  enumerable: true,
  get: function () {
    return _integration4.unleashIntegration;
  }
});
Object.defineProperty(exports, "updateSpanName", {
  enumerable: true,
  get: function () {
    return _core.updateSpanName;
  }
});
Object.defineProperty(exports, "winjsStackLineParser", {
  enumerable: true,
  get: function () {
    return _stackParsers.winjsStackLineParser;
  }
});
Object.defineProperty(exports, "withActiveSpan", {
  enumerable: true,
  get: function () {
    return _core.withActiveSpan;
  }
});
Object.defineProperty(exports, "withIsolationScope", {
  enumerable: true,
  get: function () {
    return _core.withIsolationScope;
  }
});
Object.defineProperty(exports, "withScope", {
  enumerable: true,
  get: function () {
    return _core.withScope;
  }
});
Object.defineProperty(exports, "zodErrorsIntegration", {
  enumerable: true,
  get: function () {
    return _core.zodErrorsIntegration;
  }
});

var _core = require("@sentry/core");

var _helpers = require("./helpers.js");

var _client = require("./client.js");

var _fetch = require("./transports/fetch.js");

var _stackParsers = require("./stack-parsers.js");

var _eventbuilder = require("./eventbuilder.js");

var _userfeedback = require("./userfeedback.js");

var _sdk = require("./sdk.js");

var _breadcrumbs = require("./integrations/breadcrumbs.js");

var _globalhandlers = require("./integrations/globalhandlers.js");

var _httpcontext = require("./integrations/httpcontext.js");

var _linkederrors = require("./integrations/linkederrors.js");

var _browserapierrors = require("./integrations/browserapierrors.js");

var _lazyLoadIntegration = require("./utils/lazyLoadIntegration.js");

var _reportingobserver = require("./integrations/reportingobserver.js");

var _httpclient = require("./integrations/httpclient.js");

var _contextlines = require("./integrations/contextlines.js");

var _replay = require("@sentry-internal/replay");

var _replayCanvas = require("@sentry-internal/replay-canvas");

var _feedbackAsync = require("./feedbackAsync.js");

var _feedbackSync = require("./feedbackSync.js");

var _feedback = require("@sentry-internal/feedback");

var _metrics = require("./metrics.js");

var _request = require("./tracing/request.js");

var _browserTracingIntegration = require("./tracing/browserTracingIntegration.js");

var _offline = require("./transports/offline.js");

var _integration = require("./profiling/integration.js");

var _spotlight = require("./integrations/spotlight.js");

var _browsersession = require("./integrations/browsersession.js");

var _featureFlagsIntegration = require("./integrations/featureFlags/featureFlagsIntegration.js");

var _integration2 = require("./integrations/featureFlags/launchdarkly/integration.js");

var _integration3 = require("./integrations/featureFlags/openfeature/integration.js");

var _integration4 = require("./integrations/featureFlags/unleash/integration.js");

var _integration5 = require("./integrations/featureFlags/statsig/integration.js");